import { DEPARTMENT_MANAGER, SU_ADMIN } from 'config/roles';
import { apiUrl } from 'config/settings';
import http from '../http'
import axios from 'axios'
import { useDispatch } from 'react-redux';
import { setBiz } from 'store/bizSlice';
import { setClients } from 'store/clientsSlice';
import { setDepartments } from 'store/departmentsSlice';
import { setEmployees } from 'store/employeesSlice';
import { setInfo, setMcList } from 'store/mcSlice';
import { setChangeBizLoading, setShowLoading, setShowMassage } from 'store/sysSlice';
import { setIsLogin } from 'store/userSettingsSlice';
import useWebSocket from './useWebSocket';
import { MC_SOFTWARE_TYPE, MC_ST_LOCATION, MC_WIHT_RELAY, MC_WITH_TEMP_REPORTS } from 'config/const';
import { setNotifications } from 'store/notificationSlice';
import { sortArray } from 'config/functions';

const useDataManager = () => {
  const { connected, disconnected } = useWebSocket();
  const dispatch = useDispatch()

  const getInitData = (userRole) => {
    getClients(userRole)
    getEmployees(userRole)
    getDepartmentsList()
    getNotification()
    getMcList()
  }

  const addItem = (item, list) => {
    let newList = [...list];
    const id = item?._id || item?.id
    const hasId = newList?.some(item => item?.id === id || item?._id === id)
    if (!hasId && id)
      newList.push(item);
    return newList;
  };

  const editItem = (item, list) => {
    let newList = [...list];
    const id = item?._id || item?.id
    if (id) {
      const findIndex = newList.findIndex((i) => i?._id === id || i?.id === id);
      if (findIndex !== -1)
        newList[findIndex] = { ...newList[findIndex], ...item };
    }
    return newList;
  };

  const removeItem = (id, list) => {
    let newList = [...list];
    if (id) {
      newList = newList.filter((i) => i._id !== id && i.id !== id);
    }
    return newList;
  };

  const getClients = (userRole) => {
    http.get(`${apiUrl}/clients`).then((response) => {
      if (response?.status === 200)
        dispatch(setClients(response?.data?.data));
    }).catch(error => {
      dispatch(setShowMassage({ massage: "GET_CLIENTS_ERROR", type: "error" }));
    })
  }

  const getNotification = () => {
    http.get(`${apiUrl}/notification`).then((res) => {
      dispatch(setNotifications(sortArray(res?.data?.data, "created", true)))
    }).catch(error => {
      dispatch(setShowMassage({ massage: "GET_NOTIFICATION_ERROR", type: "error" }));
    })
  };

  const getEmployees = (userRole) => {
    if (DEPARTMENT_MANAGER.includes(userRole)) {
      http.get(`${apiUrl}/employees`).then((res) => {
        dispatch(setEmployees(res?.data?.data))
      }).catch(error => {
        dispatch(setShowMassage({ massage: "GET_EMPLOYEES_ERROR", type: "error" }));
      })
    }
  };

  const getDepartmentsList = () => {
    http.get(`${apiUrl}/departments`).then((res) => {
      dispatch(setDepartments(res?.data?.data))
    }).catch(error => {
      dispatch(setShowMassage({ massage: "GET_DEPARTMENTS_ERROR", type: "error" }));
    })
  };

  const getMcList = () => {
    http.get(`${apiUrl}/mc`).then((res) => {
      let resData = res?.data?.data || []
      let info = { hasMcB2: false, hasMcB1: false }

      resData = resData?.map(mc => {
        if (mc?.softwareType === MC_SOFTWARE_TYPE.B2_0) info.hasMcB2 = true
        if (mc?.softwareType === MC_SOFTWARE_TYPE.B1_8) info.hasDHT = true
        if (mc?.softwareType !== MC_SOFTWARE_TYPE.B2_0) info.hasMcB1 = true

        if (MC_WITH_TEMP_REPORTS.includes(mc?.softwareType)) info.hasTempReports = true
        if (MC_WIHT_RELAY.includes(mc?.softwareType)) info.hasRelayReports = true

        if ((mc?.softwareType === MC_SOFTWARE_TYPE.B2_0 || mc?.softwareType === MC_SOFTWARE_TYPE.B1_7) && mc?.isConnected)
          mc.turnOnDate = new Date()
        if ((mc?.softwareType === MC_SOFTWARE_TYPE.B2_0 || mc?.softwareType === MC_SOFTWARE_TYPE.B1_7) && !mc?.isConnected)
          mc.turnOffDate = new Date()
        return mc
      })

      dispatch(setMcList(resData))
      dispatch(setInfo(info))
    }).catch(error => {
      dispatch(setShowMassage({ massage: "GET_DEPARTMENTS_ERROR", type: "error" }));
    })
  };

  const selectBiz = async (bizId, isLogin) => {
    if (bizId) {
      localStorage.setItem("biz", JSON.stringify({ id: bizId }));
      disconnected()

      setTimeout(() => {
        http.get(`${apiUrl}/business/settings/${bizId}`)
          .then((res) => {
            const biz = res?.data;
            connected(biz?.path)
            localStorage.setItem("biz", JSON.stringify(biz));
            dispatch(setBiz(biz));

            if (isLogin) {
              dispatch(setIsLogin(isLogin));
            }
            else {
              window.location.replace("/Dashboard");
              dispatch(setChangeBizLoading(false));
            }
          });
      }, 100);
    }
  };

  const notificationReadBy = (item, user, list) => {
    if (item?.readBy?.some(i => i?.employee?._id === user?.id)) return

    dispatch(setShowLoading(true));
    http.patch(`${apiUrl}/notification/readBy/${item?.id}`)
      .then((res) => {
        dispatch(setShowLoading(false));
        const newItem = {
          ...item,
          readBy: [...item?.readBy, { created: new Date(), employee: { _id: user?.id, fn: user?.fn, ln: user?.ln } }]
        }
        const newList = editItem(newItem, list);
        dispatch(setNotifications(newList));
      })
      .catch((error) => {
        dispatch(setShowLoading(false));
      });
  };

  return {
    getInitData,
    addItem,
    editItem,
    removeItem,
    getClients,
    getNotification,
    getEmployees,
    getDepartmentsList,
    notificationReadBy,
    getMcList,
    selectBiz,
  };
};

export default useDataManager;
